
export function trackUrl(domain, pageinfo) {
    let _info = {
        channel: 'compus',
        pagetype: 'operation',
        page: domain,
        pageinfo: pageinfo
    };
    window._trackURL = JSON.stringify(_info);
    window.TJ58 = false;
    let tracklog = document.getElementById('tracklog');
    if (tracklog) {
        let parentNode = tracklog.parentNode;
        if (parentNode) {
            parentNode.removeChild(tracklog);
        }
    }

    let tracklog58 = document.createElement('script');
    tracklog58.type = 'text/javascript';
    tracklog58.id = 'tracklog';
    tracklog58.src = 'http://tracklog.58.com/referrer_chinahr_pc.js';
    tracklog58.async = true;
    document.body.appendChild(tracklog58);
}
export default trackUrl;

export function analytics(projectId) {
    let node = document.getElementById('ats_analytics');
    if(node){
        let parentNode = node.parentNode;
        if (parentNode) {
            parentNode.removeChild(node);
        }
    }
    let analytics = document.createElement('script');
    analytics.type = 'text/javascript';
    analytics.id = 'ats_analytics';
    analytics.src = `http://rmsstat.chinahr.com/analytics?projectId=${projectId}`;
    analytics.async = true;
    document.body.appendChild(analytics);
}


// WEBPACK FOOTER //
// ./_source/cqsx/library/track-url.js